/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import MetaPixelCode from "@/app/components/MetaPixelCode";

export default function BeforeMainContent () {
    return <MetaPixelCode />;
}